module.exports = __webpack_public_path__ + "static/bg-contact-99df2d36794b511a8b409416e636e051.jpg";